import Sync from "@mui/icons-material/Sync";
import { Alert, DialogContentText } from "@mui/material";
import { ConfirmDialog, ResourceList } from "components/ConfirmDialog";
import { JobStatus, JobTask } from "generated-graphql/graphql";

import { useRequeueJob } from "./api";
import { isRequeueWarnTask } from "./utils";

export function RequeueJobConfirmDialog({
  open,
  onClose,
  jobId,
  task,
  status,
  onRequeued,
}: {
  open: boolean;
  onClose: () => void;
  jobId: string;
  task?: JobTask | null;
  status?: JobStatus | null;
  onRequeued?: () => void;
}) {
  const { requeue, loading } = useRequeueJob(() => {
    onRequeued?.();
    onClose();
  });

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      loading={loading}
      header="Re-queue job?"
      confirmText="Re-queue"
      confirmStartIcon={<Sync />}
      onConfirm={() => requeue(jobId)}
    >
      <ResourceList
        resources={[
          { resourceType: "Task", resourceName: task ?? "" },
          { resourceType: "Status", resourceName: status ?? "" },
        ]}
      />
      {isRequeueWarnTask(task) ? (
        <Alert severity="warning">
          Re-running this job may re-send an email or Slack message. Confirm it didn&apos;t already
          go out before re-queueing.
        </Alert>
      ) : (
        <DialogContentText>This resets the job to QUEUED so it runs again.</DialogContentText>
      )}
    </ConfirmDialog>
  );
}
